import { useCachedApiCall } from '@hooks/apiCall';
import type { UseCachedApiCallResult } from '@hooks/apiCall/useCachedApiCall';
import { PatternCase } from '@lib/utils';
import { employeeCache, employeesCache } from './employeeStore';
import type { Employee } from 'src/api/EmployeeService';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 */

/** Cache-backed employee list of a department. */
export const useEmployeesEntry = (
    departmentId?: string,
): UseCachedApiCallResult<Employee[]> =>
    useCachedApiCall(employeesCache, [departmentId]);

/*
 * Cache-backed employee list including all pattern series — the planner
 * projection (EmployeeCases tabs). A separate cache entry from the plain
 * list; invalidateEmployees drops both.
 */
export const useAllPatternsEmployeesEntry = (
    departmentId?: string,
): UseCachedApiCallResult<Employee[]> =>
    useCachedApiCall(employeesCache, [departmentId, PatternCase.ALL_PATTERNS]);

/** Cache-backed detail of a single employee. */
export const useEmployeeEntry = (
    departmentId?: string,
    employeeId?: string,
): UseCachedApiCallResult<Employee> =>
    useCachedApiCall(employeeCache, [departmentId, employeeId]);
